module.exports = __webpack_public_path__ + "static/media/bonhomme_fleche.30c03417.png";